var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"com-page"},[_c('div',{staticClass:"com-page-header",class:{
            'insurance-page': _vm.isFromInsurance,
            'sticky-header': _vm.stickyHeader,
        },style:({
            'margin-left': _vm.collapseMenu ? '100px': '',
            'margin-right': _vm.noPadding ? 0 : '',
            'margin-top': _vm.noPadding ? 0: '',
            'padding-left': _vm.noPadding ? 0 : '',
        })},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"com-page-body",style:({
            'box-shadow': _vm.showShadow ? '0 3px 6px -2px rgba(0,0,0,0.1)' : 'none',
            'margin-top': _vm.noPaddingBody ? '0' : '',
            'margin-right': _vm.noPaddingBody ? '0' : '',
            'margin-bottom': _vm.noPaddingBody ? '0' : '',
            'margin-left': _vm.noPaddingBody ? '102px' : (_vm.collapseMenu ? '116px' : ''),
            'background-color': _vm.transparent ? '': '#FFF',
            'box-shadow': _vm.transparent ? 'none': '',
            'padding': _vm.transparent ? '0': '24px',
            'padding-top': _vm.transparent ? '0': '10px',
            'padding-bottom': _vm.transparent ? '0': '10px'})},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }